export interface Layout {
    radiant: {
        background: {
            isNegative: boolean;
        };
        circle: {
            isNegative: boolean;
        };
    };
}
